import api from './api';

export const getOfficeLocations = () => api.get('/admin/office-locations');
export const createOfficeLocation = (data: any) =>
  api.post('/admin/office-locations', data);
export const updateOfficeLocation = (id: number, data: any) =>
  api.put(`/admin/office-locations/${id}`, data);
export const deleteOfficeLocation = (id: number) =>
  api.delete(`/admin/office-locations/${id}`);
